/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DefinitionStyleType {
    NumberedList = 'NumberedList',
    Paragraphs = 'Paragraphs'
}

export function DefinitionStyleTypeFromJSON(json: any): DefinitionStyleType {
    return DefinitionStyleTypeFromJSONTyped(json, false);
}

export function DefinitionStyleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinitionStyleType {
    return json as DefinitionStyleType;
}

export function DefinitionStyleTypeToJSON(value?: DefinitionStyleType | null): any {
    return value as any;
}

